/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportSdtPosition } from '../fn/pdf-export/export-sdt-position';
import { ExportSdtPosition$Params } from '../fn/pdf-export/export-sdt-position';
import { exportTunnelSection } from '../fn/pdf-export/export-tunnel-section';
import { ExportTunnelSection$Params } from '../fn/pdf-export/export-tunnel-section';

@Injectable({ providedIn: 'root' })
export class PdfExportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exportTunnelSection()` */
  static readonly ExportTunnelSectionPath = '/v1/pdfexport/tunnelsection/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportTunnelSection()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTunnelSection$Response(params: ExportTunnelSection$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportTunnelSection(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportTunnelSection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTunnelSection(params: ExportTunnelSection$Params, context?: HttpContext): Observable<Blob> {
    return this.exportTunnelSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportSdtPosition()` */
  static readonly ExportSdtPositionPath = '/v1/pdfexport/sdtposition/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSdtPosition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSdtPosition$Response(params: ExportSdtPosition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSdtPosition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSdtPosition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSdtPosition(params: ExportSdtPosition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSdtPosition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
